<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          title="Protocol sites"
          hide-create
          upsert-max-width="850px"
          :subtitle="protocol.name"
          :config="config"
          @sitecode='sitecode'
          :hidden-fields="{ protocol_id }"
          :filters="{ protocol_id }">
          <template slot='headerActions'>
            <v-btn
              color="red"
              @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>              
          </template>
        </app-table>

        <v-dialog
          v-model='openSitecode'
          max-width='750px'>
          <app-table
            v-if='openSitecode'
            :config='sitecodeConfig'
            :hidden-fields="{ site_id, protocol_id }"
            :filters="{ site_id, protocol_id }"
            no-search
            modal
            hide-upsert
            inline-upsert
            title="Provider codes"
            @close="openSitecode=false" />

        </v-dialog>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import sitecodeConfig from './config_sitecode.js'

import { getDetail } from '@/api/base_entity'
export default {
  data () {
    return {
      config,
      protocol: {},
      protocol_id: null,
      site_id: null,
      openSitecode: false,
      sitecodeConfig
    }
  },
  async created () {
    this.protocol_id= Number(this.$route.params.protocolId)
    this.protocol = await getDetail('protocol', { id: this.$route.params.protocolId })
  },
  methods: {
    sitecode (item) {
      this.site_id = item.site_id
      this.openSitecode = true
    }
  }
}
</script>
